import Markdown from "react-markdown";

interface TruncatedCellProps {
  content: string;
  maxChars?: number;
  shouldUseMarkdown?: boolean;
}

export const TruncatedCell = ({
  content,
  maxChars = 50,
  shouldUseMarkdown = false,
}: TruncatedCellProps) => {
  const isTruncated = content.length > maxChars;

  const displayContent = isTruncated
    ? content.substring(0, maxChars) + "..."
    : content;

  return (
    <div className="relative group">
      {shouldUseMarkdown ? (
        <Markdown>{displayContent}</Markdown>
      ) : (
        <div>{displayContent}</div>
      )}

      {isTruncated && (
        <div className="absolute z-50 invisible group-hover:visible bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100 p-4 rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 w-full max-w-4xl top-0 left-0 mt-5 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="max-h-48 overflow-y-auto">
            {shouldUseMarkdown ? (
              <Markdown className="whitespace-normal break-words">
                {content}
              </Markdown>
            ) : (
              <div className="whitespace-normal break-words">{content}</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export const createTruncatedCell = (
  maxChars?: number,
  shouldUseMarkdown?: boolean,
) => {
  return ({ getValue }: { getValue: () => unknown }) => {
    const value = getValue();
    return (
      <TruncatedCell
        content={String(value)}
        maxChars={maxChars}
        shouldUseMarkdown={shouldUseMarkdown}
      />
    );
  };
};
